import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Lens, LockClock, OnlinePredictionRounded, RadioButtonUnchecked, SensorsRounded, WarningRounded, } from '@mui/icons-material';
import { Box, SvgIcon } from '@mui/material';
import * as classnames from 'classnames';
import { CustomIcon } from 'console/shared/components/icon/custom';
import { isEqual } from 'lodash';
import { DeviceIconState } from 'console/device/icon/types';
import Lock from 'console/shared/components/panels/vehicle-panel/components/controls/button/icons/guard-turned-on.svg';
import Unlock from 'console/shared/components/panels/vehicle-panel/components/controls/button/icons/guard-unlock.svg';
import RideIcon from 'console/images/device-icons/autoscan/device-ride.svg';
const size = {
    width: '1.1em',
    height: '1.1em',
};
const Color = memo(function Color(props) {
    const { children, is_alarm } = props;
    return (_jsx(Box, { display: "flex", alignItems: "center", color: ({ palette }) => is_alarm
            ? undefined
            : palette.mode === 'dark'
                ? 'neutral_dark.light'
                : 'neutral_dark.main', children: children }));
});
export const DeviceStateIcon = memo(function DeviceStateIcon(props) {
    const { state, is_alarm, ...rest } = props;
    const icon_class = `ui-icon-device-${state}`;
    switch (state) {
        case DeviceIconState.alarm:
            return (_jsx(CustomIcon, { Icon: WarningRounded, color: is_alarm ? undefined : 'error', ...size, ...rest }));
        case DeviceIconState.guard_zone_alarm:
            return (_jsx(CustomIcon, { Icon: OnlinePredictionRounded, color: is_alarm ? undefined : 'warning', ...size, ...rest }));
        case DeviceIconState.sensor_alarm:
            return (_jsx(CustomIcon, { Icon: SensorsRounded, color: is_alarm ? undefined : 'warning', ...size, ...rest }));
        case DeviceIconState.online:
            return (_jsx(CustomIcon, { Icon: Lens, color: is_alarm ? undefined : 'success', ...size, ...rest }));
        case DeviceIconState.offline:
            return (_jsx(CustomIcon, { Icon: RadioButtonUnchecked, color: is_alarm ? undefined : 'error', ...size, ...rest }));
        case DeviceIconState.guard_on:
            return (_jsx(Color, { is_alarm: is_alarm, children: _jsx(CustomIcon, { Icon: Lock, color: is_alarm ? undefined : 'inherit', ...size, ...rest }) }));
        case DeviceIconState.guard_enabling:
            return (_jsx(Color, { is_alarm: is_alarm, children: _jsx(CustomIcon, { Icon: LockClock, color: is_alarm ? undefined : 'inherit', ...size, ...rest }) }));
        case DeviceIconState.guard_off:
            return (_jsx(Color, { is_alarm: is_alarm, children: _jsx(CustomIcon, { Icon: Unlock, color: is_alarm ? undefined : 'error', ...size, ...rest }) }));
        case DeviceIconState.guard_off_silent:
            return (_jsx(Color, { is_alarm: is_alarm, children: _jsx(CustomIcon, { Icon: Unlock, color: is_alarm ? undefined : 'inherit', ...size, ...rest }) }));
        case DeviceIconState.online_ride:
            return (_jsx(Color, { is_alarm: is_alarm, children: _jsx(CustomIcon, { Icon: RideIcon, color: is_alarm ? undefined : 'success', ...size, ...rest }) }));
        default:
            return (_jsx(SvgIcon, { className: classnames('ui-device-list-device-icon', icon_class), ...rest }));
    }
}, (prev_props, next_props) => isEqual(prev_props, next_props));
